'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Helpers = require('common/Helpers');

var _collectionDom = require('scripts/templates/collections/collection-dom.js');

var storage = {
  wasOnPDP: 'pitviperWasOnPDP',
  lastCollection: 'pitviperLastCollectionVisited',
  collectionScrollPosition: 'pitviperCollectionPosition',
  collectionSectionsLoaded: 'pitviperCollectionLoaded'
};

var scrollDebouncer = (0, _Helpers.debounce)(function () {
  sessionStorage.setItem(storage.collectionScrollPosition, document.documentElement.scrollTop);
}, 500);

var setupListeners = function setupListeners() {
  var loadMore = document.querySelector(_collectionDom.collectionDom.productLoadMore) || false;
  if (loadMore) loadMore.addEventListener('click', addLoadedPage);
  window.addEventListener('scroll', scrollDebouncer);
};

/**
 * Gets a session storage value, and returns as the proper value type
 */
var getStorageItem = function getStorageItem(storageItem) {
  var value = sessionStorage.getItem(storageItem);
  if (!isNaN(value)) return parseInt(value, 10);
  return value;
};

var setLastCollectionVisited = function setLastCollectionVisited() {
  var currentCollection = window.bvaccel.collection.handle;
  sessionStorage.setItem(storage.lastCollection, currentCollection);
};

/**
 * Will load a number of tile sections previously loaded and then
 * scroll the page down to where the user was at previously.
 */
var scrollToPosition = function scrollToPosition() {
  var currentCollection = window.bvaccel.collection.handle;
  var onSameCollection = currentCollection === getStorageItem(storage.lastCollection);
  var shouldScroll = onSameCollection && getStorageItem(storage.wasOnPDP) === 'true';

  setLastCollectionVisited();

  if (shouldScroll === false) return;

  var pagesLoaded = getStorageItem(storage.collectionSectionsLoaded);
  var scrollTo = getStorageItem(storage.collectionScrollPosition);
  var loadMore = document.querySelector(_collectionDom.collectionDom.productLoadMore) || false;
  for (var a = 0; a < pagesLoaded; a++) {
    if (loadMore) loadMore.click();
  }

  window.scrollTo({
    top: scrollTo
  });

  // reset the page
  sessionStorage.setItem(storage.wasOnPDP, false);
  sessionStorage.setItem(storage.collectionSectionsLoaded, pagesLoaded);
};

/**
 * Increments the number of loaded sections on the current collection page
 */
var addLoadedPage = function addLoadedPage() {
  var extraSectionsLoaded = getStorageItem(storage.collectionSectionsLoaded) || 0;
  sessionStorage.setItem(storage.collectionSectionsLoaded, extraSectionsLoaded + 1);
};

/**
 * Sets the currently viewed page to determine if the user is on a PDP
 * from a collections page
 */
var setup = function setup() {
  if (window.bvaccel.template.name === 'collection') return;

  var onPDP = window.bvaccel.template.name === 'product' && document.referrer.includes('/collections/');
  sessionStorage.setItem(storage.wasOnPDP, onPDP);
  if (onPDP === false) {
    sessionStorage.setItem(storage.collectionSectionsLoaded, 0);
    sessionStorage.setItem(storage.collectionScrollPosition, 0);
  }
};

exports.default = {
  setup: setup,
  addLoadedPage: addLoadedPage,
  scrollToPosition: scrollToPosition,
  setupListeners: setupListeners
};